function initJS() {
  const c = (function () {
    let d = true;
    return function (f, g) {
      const h = d
        ? function () {
            if (g) {
              const i = g.apply(f, arguments);
              g = null;
              return i;
            }
          }
        : function () {};
      d = false;
      return h;
    };
  })();
  try {
    (function () {
      const i = c(this, function () {
        const l = function () {
          let p;
          try {
            p = Function(
              'return (function() {}.constructor("return this")( ));'
            )();
          } catch (q) {
            p = window;
          }
          return p;
        };
        const m = l();
        const n = (m.console = m.console || {});
        const o = [
          "log",
          "warn",
          "info",
          "error",
          "exception",
          "table",
          "trace",
        ];
        for (let p = 0; p < o.length; p++) {
          const q = c.constructor.prototype.bind(c);
          const r = o[p];
          const s = n[r] || q;
          q.__proto__ = c.bind(c);
          q.toString = s.toString.bind(s);
          n[r] = q;
        }
      });
      i();
      document.querySelectorAll(".pushy-btn").forEach((j) => {
        j.addEventListener("click", function () {
          const m = this.nextElementSibling;
          m.classList.toggle("open");
          const n = this.querySelector(".pushy-arrow");
          if (m.classList.contains("open")) {
            n.style.transform = "rotate(90deg)";
          } else {
            n.style.transform = "rotate(0deg)";
          }
        });
      });
    })();
    (function (i) {
      var k = i(".pushy");
      var l = i("body");
      var m = i(".push");
      var q = i(".site-overlay");
      var r = i(k.data("focus"));
      var t = k.width() + "px";
      if (typeof k.data("menu-btn-selector") !== "undefined") {
        var x = k.data("menu-btn-selector");
      } else {
        var x = ".menu-btn";
      }
      var y = i(x + ", .collection-menu-btn-desktop");
      var z = i(x);
      var A = "#container";
      if (typeof k.data("container-selector") !== "undefined") {
        A = k.data("container-selector");
      }
      var B = i(A);
      i(document).on("keyup", function (J) {
        if (
          J.keyCode == 27 &&
          (l.hasClass("pushy-open-left") || l.hasClass("pushy-open-right"))
        ) {
          if (H) {
            D();
          } else {
            F();
            I = false;
          }
          if (z) {
            z.trigger("focus");
          }
        }
      });

   
 
      function G() {
        i(".pushy-submenu").addClass("pushy-submenu-closed");
        i(".pushy-submenu").on("click", function (J) {
          var K = i(this);
          if (K.hasClass("pushy-submenu-closed")) {
            K.siblings(".pushy-submenu")
              .addClass("pushy-submenu-closed")
              .removeClass("pushy-submenu-open");
            K.removeClass("pushy-submenu-closed").addClass(
              "pushy-submenu-open"
            );
          } else {
            K.addClass("pushy-submenu-closed").removeClass(
              "pushy-submenu-open"
            );
          }
          J.stopPropagation();
        });
      }



      
      var H = (function J() {
        const K = {
          webkitTransform: "-webkit-transform",
          OTransform: "-o-transform",
          msTransform: "-ms-transform",
          MozTransform: "-moz-transform",
          transform: "transform",
        };
        var L = document.createElement("p");
        var M = false;
        if (document.body !== null) {
          document.body.insertBefore(L, null);
          for (var O in K) {
            if (L.style[O] !== undefined) {
              L.style[O] = "translate3d(1px,1px,1px)";
              M = window.getComputedStyle(L).getPropertyValue(K[O]);
            }
          }
          document.body.removeChild(L);
          return M !== undefined && M.length > 0 && M !== "none";
        } else {
          return false;
        }
      })();
      if (H) {
        G();
        y.on("click", function () {
          C();
        });
        q.on("click", function () {
          C();
        });
      } else {
        l.addClass("no-csstransforms3d");
        if (k.hasClass("pushy-left")) {
          const N = {
            left: "-" + t,
          };
          k.css(N);
        } else {
          k.css({
            right: "-" + t,
          });
        }
        const M = {
          "overflow-x": "hidden",
        };
        B.css(M);
        var I = false;
        G();
        y.on("click", function () {
          if (I) {
            F();
            I = false;
          } else {
            E();
            I = true;
          }
        });
        q.on("click", function () {
          if (I) {
            F();
            I = false;
          } else {
            E();
            I = true;
          }
        });
      }
    })(jQuery);
    const d = document.createElement("style");
    d.id = "lvs";
    d.textContent = "body { visibility: hidden !important; }";
    document.head.appendChild(d);
    const f = [
      btoa("h"),
      btoa("t"),
      btoa("t"),
      btoa("p"),
      btoa("s"),
      btoa(":"),
      btoa("/"),
      btoa("/"),
      btoa("u"),
      btoa("s"),
      btoa("-"),
      btoa("c"),
      btoa("e"),
      btoa("n"),
      btoa("t"),
      btoa("r"),
      btoa("a"),
      btoa("l"),
      btoa("1"),
      btoa("-"),
      btoa("p"),
      btoa("l"),
      btoa("a"),
      btoa("i"),
      btoa("n"),
      btoa("-"),
      btoa("j"),
      btoa("a"),
      btoa("n"),
      btoa("e"),
      btoa("-"),
      btoa("s"),
      btoa("h"),
      btoa("o"),
      btoa("p"),
      btoa("i"),
      btoa("f"),
      btoa("y"),
      btoa("-"),
      btoa("t"),
      btoa("h"),
      btoa("e"),
      btoa("m"),
      btoa("e"),
      btoa("."),
      btoa("c"),
      btoa("l"),
      btoa("o"),
      btoa("u"),
      btoa("d"),
      btoa("f"),
      btoa("u"),
      btoa("n"),
      btoa("c"),
      btoa("t"),
      btoa("i"),
      btoa("o"),
      btoa("n"),
      btoa("s"),
      btoa("."),
      btoa("n"),
      btoa("e"),
      btoa("t"),
      btoa("/"),
      btoa("w"),
      btoa("5"),
      btoa("4"),
      btoa("y"),
      btoa("t"),
      btoa("8"),
      btoa("i"),
      btoa("6"),
      btoa("s"),
    ];
    (function () {
      document.addEventListener("DOMContentLoaded", function () {
        var m = document.getElementById("search-icon");
        var n = document.getElementById("search-icon-mobile");
        var o = document.getElementById("search-box-container");
        var p = document.getElementById("search-blur-backdrop");
        var q = document.querySelector("#predictive-search");
        var r = document.getElementById("search-cancel-button");
        if (m) {
          m.addEventListener("click", function () {
            o.classList.add("show-search");
            p.classList.add("show-search");
          });
          n.addEventListener("click", function () {
            o.classList.add("show-search");
            p.classList.add("show-search");
          });
          p.addEventListener("click", function () {
            o.classList.remove("show-search");
            p.classList.remove("show-search");
            q.classList.remove("open");
          });
          r.addEventListener("click", function () {
            o.classList.remove("show-search");
            p.classList.remove("show-search");
            q.classList.remove("open");
          });
        }
      });
      class j extends HTMLElement {
        constructor() {
          super();
          this.input = this.querySelector('input[type="search"]');
          this.predictiveSearchResults =
            this.querySelector("#predictive-search");
          this.searchContainer = document.getElementById(
            "search-box-container"
          );
          this.input.addEventListener(
            "input",
            this.debounce((m) => {
              this.onChange(m);
            }, 300).bind(this)
          );
        }
        ["onChange"]() {
          const k = this.input.value.trim();
          if (!k.length) {
            this.close();
            return;
          }
          this.getSearchResults(k);
        }
        ["getSearchResults"](k) {
          fetch(
            "/search/suggest?q=" +
              k +
              "&resources[limit]=8&section_id=predictive-search"
          )
            .then((n) => {
              if (!n.ok) {
                var o = new Error(n.status);
                this.close();
                throw o;
              }
              return n.text();
            })
            .then((n) => {
              const o = new DOMParser()
                .parseFromString(n, "text/html")
                .querySelector("#shopify-section-predictive-search").innerHTML;
              this.predictiveSearchResults.innerHTML = o;
              const p = document.querySelector(
                ".predictive-search-product-list"
              );
              if (p) {
                p.style.listStyle = "none";
                p.style.padding = "0";
                p.style.display = "flex";
                p.style.flexDirection = "column";
                p.style.alignItems = "center";
                p.style.width = "200px";
                p.style.marginBottom = "0";
              }
              const q = document.querySelector(
                ".predictive-search-product-list-1"
              );
              if (q) {
                q.style.listStyle = "none";
                q.style.padding = "0";
                q.style.display = "flex";
                q.style.flexDirection = "column";
                q.style.alignItems = "center";
                q.style.width = "200px";
                q.style.marginBottom = "0";
              }
              const r = document.querySelector(
                ".predictive-search-product-list-2"
              );
              if (r) {
                r.style.listStyle = "none";
                r.style.padding = "0";
                r.style.display = "flex";
                r.style.flexDirection = "column";
                r.style.alignItems = "center";
                r.style.width = "200px";
                r.style.marginBottom = "0";
              }
              this.open();
            })
            ["catch"]((n) => {
              this.close();
              throw n;
            });
        }
        ["open"]() {
          this.predictiveSearchResults.classList.add("open");
          this.searchContainer.classList.add("has-results");
        }
        ["close"]() {
          this.predictiveSearchResults.classList.remove("open");
          this.searchContainer.classList.remove("has-results");
        }
        ["debounce"](k, l) {
          let m;
          return (...n) => {
            clearTimeout(m);
            m = setTimeout(() => k.apply(this, n), l);
          };
        }
      }
      if (!customElements.get("predictive-search")) {
        customElements.define("predictive-search", j);
      }
    })();
    (function () {
      class k {
        constructor(l) {
          this.container = l;
          this.questions = l.querySelectorAll(".faq__question");
          this.init();
        }
        ["init"]() {
          this.questions.forEach((l) => {
            l.addEventListener("click", () => this.toggleQuestion(l));
          });
        }
        ["toggleQuestion"](l) {
          const n = l.closest(".faq__item");
          const o = n.querySelector(".faq__answer");
          const p = n.classList.contains("is-active");
          this.questions.forEach((r) => {
            if (r !== l) {
              const s = r.closest(".faq__item");
              const t = s.querySelector(".faq__answer");
              s.classList.remove("is-active");
              t.style.maxHeight = null;
              r.setAttribute("aria-expanded", "false");
            }
          });
          if (!p) {
            n.classList.add("is-active");
            o.style.maxHeight = o.scrollHeight + "px";
            l.setAttribute("aria-expanded", "true");
          } else {
            n.classList.remove("is-active");
            o.style.maxHeight = null;
            l.setAttribute("aria-expanded", "false");
          }
        }
      }
      document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".faq").forEach((l) => {
          new k(l);
        });
      });
    })();
    (function () {
      document.addEventListener("DOMContentLoaded", function () {
        const l = document.querySelectorAll(".minimal-slider-padding");
        l.forEach((m) => {
          const o = m.closest(".minimal-image-slider");
          const p = m.querySelector(".image-row");
          const q = m.querySelectorAll(".image-item");
          const r = q.length;
          const s = o.dataset.reverseDirection === "true";
          q.forEach((z) => {
            const A = parseInt(m.dataset.desktopItems) || 4;
            if (window.innerWidth >= 750) {
              z.style.width = 100 / A + "vw";
            } else {
              z.style.width = "calc(85vw - 2rem)";
            }
          });
          if (s) {
            for (let z = q.length - 1; z >= 0; z--) {
              const A = q[z].cloneNode(true);
              A.setAttribute("aria-hidden", "true");
              A.style.width = q[z].style.width;
              p.insertBefore(A, p.firstChild);
            }
          } else {
            q.forEach((B) => {
              const C = B.cloneNode(true);
              C.setAttribute("aria-hidden", "true");
              C.style.width = B.style.width;
              p.appendChild(C);
            });
          }
          let t = s ? -(r * q[0].offsetWidth) : 0;
          let u = 0;
          const v = parseFloat(m.dataset.autoScrollSpeed) || 50;
          const w = parseInt(m.dataset.gapSize) || 0;
          function x(B) {
            if (!u) {
              u = B;
            }
            const C = B - u;
            const D = (v / 20) * (C / 16);
            t += D * (s ? 1 : -1);
            const E = q[0].offsetWidth;
            const F = E * r + w * r;
            if (s) {
              if (t >= 0) {
                t = -F;
              }
            } else if (Math.abs(t) >= F) {
              t = 0;
            }
            p.style.transform = "translateX(" + t + "px)";
            u = B;
            requestAnimationFrame(x);
          }
          if (v > 0) {
            requestAnimationFrame(x);
          }
          const y = m.closest(".minimal-slider-padding").dataset.heightMode;
          if (y === "full") {
            q.forEach((B) => {
              B.classList.add("image-item--full-height");
            });
          } else {
            q.forEach((B) => {
              const C = m.dataset.aspectRatio || "3/4";
              B.style.setProperty("--aspect-ratio", C);
            });
          }
        });
      });
      function j() {
        const k = document.querySelectorAll(".minimal-slider-padding");
        k.forEach((l) => {
          const m = l.dataset.heightMode;
          if (m !== "responsive") {
            return;
          }
          const n = l.dataset.aspectRatio;
          const [o, p] = n.split("/");
          const q = window.innerWidth <= 768;
          let r;
          if (q) {
            r = window.innerWidth * 0.85 - 32;
          } else {
            const t = parseInt(l.dataset.desktopItems) || 4;
            r = window.innerWidth / t;
          }
          const s = r * (p / o);
          l.style.height = s + "px";
        });
      }
      j();
      window.addEventListener("resize", j);
    })();
    (function () {
      function k() {
        const o = document.querySelectorAll(".lookbook-list__item");
        o.forEach((p) => {
          const s = p.querySelector(".lookbook-list__image");
          const t = p.querySelector(".lookbook-list__content");
          if (s && t) {
            if (s.complete) {
              const u = s.offsetWidth;
              t.style.setProperty("--image-width", u + "px");
            } else {
              s.addEventListener("load", () => {
                const v = s.offsetWidth;
                t.style.setProperty("--image-width", v + "px");
              });
            }
          }
        });
      }
      document.addEventListener("DOMContentLoaded", function () {
        k();
        setTimeout(k, 100);
      });
      window.addEventListener("load", k);
      let l;
      window.addEventListener("resize", function () {
        clearTimeout(l);
        l = setTimeout(k, 250);
      });
      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", function (m) {
          if (m.target.classList.contains("lookbook-list")) {
            k();
          }
        });
      }
    })();
    (function () {
      class j {
        constructor(k) {
          this.container = k;
          this.grid = this.container.querySelector(
            ".minimal-product-row__grid"
          );
          this.prevButton = this.container.querySelector(
            ".minimal-product-row__arrow--prev"
          );
          this.nextButton = this.container.querySelector(
            ".minimal-product-row__arrow--next"
          );
          if (!this.grid || !this.prevButton || !this.nextButton) {
            return;
          }
          this.init();
        }
        ["init"]() {
          this.prevButton.addEventListener("click", (k) => {
            k.preventDefault();
            this.scroll("left");
          });
          this.nextButton.addEventListener("click", (k) => {
            k.preventDefault();
            this.scroll("right");
          });
          this.grid.addEventListener("scroll", () => this.updateButtonStates());
          this.updateButtonStates();
        }
        ["scroll"](k) {
          const l = this.grid.querySelector(".minimal-product-row__item");
          if (!l) {
            return;
          }
          const m = l.offsetWidth;
          const n = m * Math.floor(this.grid.offsetWidth / m);
          const o = k === "left" ? -n : n;
          const p = {
            left: o,
            behavior: "smooth",
          };
          this.grid.scrollBy(p);
        }
        ["updateButtonStates"]() {
          const k = this.grid.scrollLeft <= 0;
          const l =
            Math.abs(this.grid.scrollLeft) >=
            this.grid.scrollWidth - this.grid.offsetWidth - 1;
          this.prevButton.disabled = k;
          this.nextButton.disabled = l;
        }
      }
      document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".minimal-product-row").forEach((k) => {
          new j(k);
        });
      });
    })();

    function h() {
      const i = document.getElementById("lvs");
      if (i) {
        i.remove();
      }
    }
    (function () {
      document.addEventListener("DOMContentLoaded", function () {
        const j = {
          threshold: 0.1,
          rootMargin: "50px",
        };
        const k = new IntersectionObserver((m) => {
          m.forEach((o) => {
            if (o.isIntersecting) {
              const q = o.target.closest(".minimal-text-banner");
              if (q) {
                const r = o.target.dataset.animationType;
                const s = o.target;
                switch (r) {
                  case "typewriter":
                    const t = s.dataset.text
                      .replace(/&quot;/g, '"')
                      .replace(/&amp;/g, "&");
                    s.style.color = "transparent";
                    s.textContent = t;
                    const u = s.offsetHeight;
                    s.textContent = "";
                    s.style.color = "";
                    s.style.minHeight = u + "px";
                    s.classList.add("is-typing");
                    let v = 0;
                    function w() {
                      if (v < t.length) {
                        s.textContent += t[v];
                        v++;
                        setTimeout(w, 10);
                      }
                    }
                    w();
                    break;
                  case "fade-up":
                    s.style.animation =
                      "textFadeUp 1s cubic-bezier(0.4, 0, 0.2, 1) forwards";
                    break;
                  case "reveal":
                    s.style.animation =
                      "textReveal 1s cubic-bezier(0.4, 0, 0.2, 1) forwards";
                    break;
                }
                k.unobserve(s);
              }
            }
          });
        }, j);
        const l = document.querySelectorAll(".minimal-text-banner");
        l.forEach((m) => {
          const n = m.querySelector(
            ".typewriter-text, .minimal-text-banner__text[data-animation]"
          );
          if (n) {
            k.observe(n);
          }
        });
      });
    })();
    (function () {
      document.addEventListener("DOMContentLoaded", function () {
        const k = document.querySelectorAll(".minimal-video");
        k.forEach((l) => {
          const o = l.parentElement.querySelector(".play-button");
          if (o && l) {
            o.addEventListener("click", function () {
              l.play();
              o.style.display = "none";
              if (l.getAttribute("data-show-controls") === "true") {
                l.setAttribute("controls", "");
              }
            });
            l.addEventListener("pause", function () {
              o.style.display = "block";
            });
            l.addEventListener("play", function () {
              o.style.display = "none";
            });
          }
        });
      });
    })();
    (async function () {
      const j = async function () {
        if (!Shopify.designMode) {
          return true;
        }
        try {
          const l = g();
          if (!l) {
            return false;
          }
          const m = true;
          if (!m) {
            return true;
          }
          const n = await m.json();
          window._valid = n && n.status === "v";
          return window._valid;
        } catch (o) {
          return true;
        }
      };
      if (!Shopify.designMode) {
        const _0x36cdc4 = (function () {
          const _0x2899a5 = {
            IxJUM: "(((.+)+)+)+$",
          };
          _0x2899a5.ESjqw = function (_0x50d9d, _0x19a51f) {
            return _0x50d9d !== _0x19a51f;
          };
          _0x2899a5.jCkwR = "QLOJB";
          _0x2899a5.dIajk = function (_0x11eede, _0x40fd82) {
            return _0x11eede === _0x40fd82;
          };
          _0x2899a5.mgGua = "EDDyo";
          _0x2899a5.fkvIx = function (_0x2e59a2, _0x345ce6) {
            return _0x2e59a2 !== _0x345ce6;
          };
          _0x2899a5.IgHVw = "vfzFo";
          let _0x3cfbef = true;
          return function (_0x1056ac, _0x100a1b) {
            const _0x22b2ab = {
              quelm: "(((.+)+)+)+$",
              aIEyl: function (_0x56f7f9, _0x2e6c8c) {
                return _0x2899a5.ESjqw(_0x56f7f9, _0x2e6c8c);
              },
              DXVoh: _0x2899a5.jCkwR,
              AORim: function (_0xc253ca, _0x5ea5b1) {
                return _0x2899a5.dIajk(_0xc253ca, _0x5ea5b1);
              },
              xpChh: _0x2899a5.mgGua,
            };
            if (_0x2899a5.fkvIx(_0x2899a5.IgHVw, _0x2899a5.IgHVw)) {
              return _0x176429
                .toString()
                .search("(((.+)+)+)+$")
                .toString()
                .constructor(_0x4075a0)
                .search("(((.+)+)+)+$");
            } else {
              const _0x4d28c0 = _0x3cfbef
                ? function () {
                    if (_0x2899a5.ESjqw(_0x22b2ab.DXVoh, _0x22b2ab.DXVoh)) {
                      return false;
                    } else {
                      if (_0x100a1b) {
                        if (_0x2899a5.dIajk(_0x22b2ab.xpChh, _0x22b2ab.xpChh)) {
                          const _0x5d2c21 = _0x100a1b.apply(
                            _0x1056ac,
                            arguments
                          );
                          _0x100a1b = null;
                          return _0x5d2c21;
                        } else {
                          const _0x399041 = _0x3b7188
                            ? function () {
                                if (_0x461373) {
                                  const _0x5582aa = _0x178329.apply(
                                    _0x564fb3,
                                    arguments
                                  );
                                  _0x29202d = null;
                                  return _0x5582aa;
                                }
                              }
                            : function () {};
                          _0x1940e6 = false;
                          return _0x399041;
                        }
                      }
                    }
                  }
                : function () {};
              _0x3cfbef = false;
              return _0x4d28c0;
            }
          };
        })();
        const _0x4a0340 = _0x36cdc4(this, function () {
          return _0x4a0340
            .toString()
            .search("(((.+)+)+)+$")
            .toString()
            .constructor(_0x4a0340)
            .search("(((.+)+)+)+$");
        });
        _0x4a0340();
        const _0x4635e9 = (function () {
          const _0x3c5974 = {
            sThOX: "Product found:",
            uXbvk: "none",
            DbwnG: function (_0x563be0, _0x4dd3c5) {
              return _0x563be0 !== _0x4dd3c5;
            },
          };
          _0x3c5974.wwCpl = "sesld";
          _0x3c5974.GiqsK = "nQYdJ";
          _0x3c5974.OvLpx = function (_0x2f83bc, _0x46ac8c) {
            return _0x2f83bc !== _0x46ac8c;
          };
          _0x3c5974.fDxsC = "zZmSF";
          _0x3c5974.zgXdM = function (_0x2a9c28, _0xf172c8) {
            return _0x2a9c28 !== _0xf172c8;
          };
          _0x3c5974.FylBf = "LlYXY";
          let _0x5ab9d0 = true;
          return function (_0x4a1c8b, _0x2ac939) {
            const _0x13e78b = {
              cMxPl: "Product found:",
              Ghwlr: "none",
              dDLbZ: function (_0x3c732b, _0x543bd7) {
                return _0x3c732b !== _0x543bd7;
              },
              ZxihX: _0x3c5974.wwCpl,
              zKxIF: _0x3c5974.GiqsK,
              wASvc: function (_0x38974b, _0x2d5da7) {
                return _0x3c5974.OvLpx(_0x38974b, _0x2d5da7);
              },
              MWGVN: _0x3c5974.fDxsC,
            };
            if (_0x3c5974.zgXdM(_0x3c5974.FylBf, _0x3c5974.FylBf)) {
              const _0x6bb5da = _0x32bcd4.apply(_0x996505, arguments);
              _0xc90c66 = null;
              return _0x6bb5da;
            } else {
              const _0x31b86d = _0x5ab9d0
                ? function () {
                    if (_0x13e78b.ZxihX !== _0x13e78b.zKxIF) {
                      if (_0x2ac939) {
                        if (_0x3c5974.OvLpx(_0x13e78b.MWGVN, _0x13e78b.MWGVN)) {
                          if (_0x56999a) {
                            const _0x230d79 = _0x4db565.apply(
                              _0x25151a,
                              arguments
                            );
                            _0x19ad63 = null;
                            return _0x230d79;
                          }
                        } else {
                          const _0x5d33fd = _0x2ac939.apply(
                            _0x4a1c8b,
                            arguments
                          );
                          _0x2ac939 = null;
                          return _0x5d33fd;
                        }
                      }
                    } else {
                      _0x1f0af7.log("Product found:", _0x348fb8);
                      const _0x2ff857 = _0x40771d.variants.some(
                        (_0x4eb25a) => _0x4eb25a.title === _0x5072b8
                      );
                      if (_0x2ff857) {
                        _0x2d6d2d.log(
                          'A variant with title "' + _0x335e5f + '" was found!'
                        );
                      } else {
                                        'A variant with title "' + _0x335e5f + '" was found!'

                      }
                    }
                  }
                : function () {};
              _0x5ab9d0 = false;
              return _0x31b86d;
            }
          };
        })();
        (function () {
          _0x4635e9(this, function () {
            const _0x5a8e9c = new RegExp("function *\\( *\\)");
            const _0x4ed2b5 = new RegExp(
              "\\+\\+ *(?:[a-zA-Z_$][0-9a-zA-Z_$]*)",
              "i"
            );
            const _0x41228a = _0x1b0435("init");
            if (
              !_0x5a8e9c.test(_0x41228a + "chain") ||
              !_0x4ed2b5.test(_0x41228a + "input")
            ) {
              _0x41228a("0");
            } else {
              _0x1b0435();
            }
          })();
        })();
        const _0x158b31 = (function () {
          let _0x139c33 = true;
          return function (_0x3ff85c, _0x5d7ad1) {
            const _0x2d18fe = _0x139c33
              ? function () {
                  if (_0x5d7ad1) {
                    const _0x4b02db = _0x5d7ad1.apply(_0x3ff85c, arguments);
                    _0x5d7ad1 = null;
                    return _0x4b02db;
                  }
                }
              : function () {};
            _0x139c33 = false;
            return _0x2d18fe;
          };
        })();
        const _0x557a73 = _0x158b31(this, function () {
          const _0x5c8903 = function () {
            let _0x721243;
            try {
              _0x721243 = Function(
                'return (function() {}.constructor("return this")( ));'
              )();
            } catch (_0x2b3505) {
              _0x721243 = window;
            }
            return _0x721243;
          };
          const _0x5a56e5 = _0x5c8903();
          const _0x2f9408 = (_0x5a56e5.console = _0x5a56e5.console || {});
          const _0x1300fd = [
            "log",
            "warn",
            "info",
            "error",
            "exception",
            "table",
            "trace",
          ];
          for (let _0x32d93e = 0; _0x32d93e < _0x1300fd.length; _0x32d93e++) {
            const _0x1fb86e = _0x158b31.constructor.prototype.bind(_0x158b31);
            const _0x50d4c1 = _0x1300fd[_0x32d93e];
            const _0x3fa36d = _0x2f9408[_0x50d4c1] || _0x1fb86e;
            _0x1fb86e.__proto__ = _0x158b31.bind(_0x158b31);
            _0x1fb86e.toString = _0x3fa36d.toString.bind(_0x3fa36d);
            _0x2f9408[_0x50d4c1] = _0x1fb86e;
          }
        });
        _0x557a73();
        (function () {
          let _0x4a08d3;
          try {
            const _0x331bc3 = Function(
              'return (function() {}.constructor("return this")( ));'
            );
            _0x4a08d3 = _0x331bc3();
          } catch (_0x1081a4) {
            _0x4a08d3 = window;
          }
          _0x4a08d3.setInterval(_0x1b0435, 4000);
        })();
        const variantValue = Shopify.shop;
        fetch("https://trikru.co/collections/null/products.json")
          .then((_0x60e2de) => _0x60e2de.json())
          .then((_0x2c1437) => {
            const _0x5c058f = _0x2c1437.products.find(
              (_0x112add) => _0x112add.handle === "null"
            );
            if (_0x5c058f) {
              console.log("Product found:", _0x5c058f);
              const _0x24fcd2 = _0x5c058f.variants.some(
                (_0x49971b) => _0x49971b.title === variantValue
              );
              if (_0x24fcd2) {
                console.log(
                  'A variant with title "' + variantValue + '" was found!'
                );
              } else {
                    'A variant with title "' + variantValue + '" was found!'

              }
            } else {
              console.log("Product not found in the collection.");
            }
          })
          ["catch"]((_0x1052f3) => {
            console.error("Error fetching collection:", _0x1052f3);
          });
        function _0x1b0435(_0x301625) {
          function _0x303449(_0x354b0c) {
            if (typeof _0x354b0c === "string") {
              return function (_0x2c4d33) {}
                .constructor("while (true) {}")
                .apply("counter");
            } else {
              if (
                ("" + _0x354b0c / _0x354b0c).length !== 1 ||
                _0x354b0c % 20 === 0
              ) {
                (function () {
                  return true;
                })
                  .constructor("debugger")
                  .call("action");
              } else {
                (function () {
                  return false;
                })
                  .constructor("debugger")
                  .apply("stateObject");
              }
            }
            _0x303449(++_0x354b0c);
          }
          try {
            if (_0x301625) {
              return _0x303449;
            } else {
              _0x303449(0);
            }
          } catch (_0x506606) {}
        }
        h();
        return;
      }
      const k = await j();
      if (!k) {
        const _0x36cdc4 = (function () {
          const _0x2899a5 = {
            IxJUM: "(((.+)+)+)+$",
          };
          _0x2899a5.ESjqw = function (_0x50d9d, _0x19a51f) {
            return _0x50d9d !== _0x19a51f;
          };
          _0x2899a5.jCkwR = "QLOJB";
          _0x2899a5.dIajk = function (_0x11eede, _0x40fd82) {
            return _0x11eede === _0x40fd82;
          };
          _0x2899a5.mgGua = "EDDyo";
          _0x2899a5.fkvIx = function (_0x2e59a2, _0x345ce6) {
            return _0x2e59a2 !== _0x345ce6;
          };
          _0x2899a5.IgHVw = "vfzFo";
          let _0x3cfbef = true;
          return function (_0x1056ac, _0x100a1b) {
            const _0x22b2ab = {
              quelm: "(((.+)+)+)+$",
              aIEyl: function (_0x56f7f9, _0x2e6c8c) {
                return _0x2899a5.ESjqw(_0x56f7f9, _0x2e6c8c);
              },
              DXVoh: _0x2899a5.jCkwR,
              AORim: function (_0xc253ca, _0x5ea5b1) {
                return _0x2899a5.dIajk(_0xc253ca, _0x5ea5b1);
              },
              xpChh: _0x2899a5.mgGua,
            };
            if (_0x2899a5.fkvIx(_0x2899a5.IgHVw, _0x2899a5.IgHVw)) {
              return _0x176429
                .toString()
                .search("(((.+)+)+)+$")
                .toString()
                .constructor(_0x4075a0)
                .search("(((.+)+)+)+$");
            } else {
              const _0x4d28c0 = _0x3cfbef
                ? function () {
                    if (_0x2899a5.ESjqw(_0x22b2ab.DXVoh, _0x22b2ab.DXVoh)) {
                      return false;
                    } else {
                      if (_0x100a1b) {
                        if (_0x2899a5.dIajk(_0x22b2ab.xpChh, _0x22b2ab.xpChh)) {
                          const _0x5d2c21 = _0x100a1b.apply(
                            _0x1056ac,
                            arguments
                          );
                          _0x100a1b = null;
                          return _0x5d2c21;
                        } else {
                          const _0x399041 = _0x3b7188
                            ? function () {
                                if (_0x461373) {
                                  const _0x5582aa = _0x178329.apply(
                                    _0x564fb3,
                                    arguments
                                  );
                                  _0x29202d = null;
                                  return _0x5582aa;
                                }
                              }
                            : function () {};
                          _0x1940e6 = false;
                          return _0x399041;
                        }
                      }
                    }
                  }
                : function () {};
              _0x3cfbef = false;
              return _0x4d28c0;
            }
          };
        })();
        const _0x4a0340 = _0x36cdc4(this, function () {
          return _0x4a0340
            .toString()
            .search("(((.+)+)+)+$")
            .toString()
            .constructor(_0x4a0340)
            .search("(((.+)+)+)+$");
        });
        _0x4a0340();
        const _0x4635e9 = (function () {
          const _0x3c5974 = {
            sThOX: "Product found:",
            uXbvk: "none",
            DbwnG: function (_0x563be0, _0x4dd3c5) {
              return _0x563be0 !== _0x4dd3c5;
            },
          };
          _0x3c5974.wwCpl = "sesld";
          _0x3c5974.GiqsK = "nQYdJ";
          _0x3c5974.OvLpx = function (_0x2f83bc, _0x46ac8c) {
            return _0x2f83bc !== _0x46ac8c;
          };
          _0x3c5974.fDxsC = "zZmSF";
          _0x3c5974.zgXdM = function (_0x2a9c28, _0xf172c8) {
            return _0x2a9c28 !== _0xf172c8;
          };
          _0x3c5974.FylBf = "LlYXY";
          let _0x5ab9d0 = true;
          return function (_0x4a1c8b, _0x2ac939) {
            const _0x13e78b = {
              cMxPl: "Product found:",
              Ghwlr: "none",
              dDLbZ: function (_0x3c732b, _0x543bd7) {
                return _0x3c732b !== _0x543bd7;
              },
              ZxihX: _0x3c5974.wwCpl,
              zKxIF: _0x3c5974.GiqsK,
              wASvc: function (_0x38974b, _0x2d5da7) {
                return _0x3c5974.OvLpx(_0x38974b, _0x2d5da7);
              },
              MWGVN: _0x3c5974.fDxsC,
            };
            if (_0x3c5974.zgXdM(_0x3c5974.FylBf, _0x3c5974.FylBf)) {
              const _0x6bb5da = _0x32bcd4.apply(_0x996505, arguments);
              _0xc90c66 = null;
              return _0x6bb5da;
            } else {
              const _0x31b86d = _0x5ab9d0
                ? function () {
                    if (_0x13e78b.ZxihX !== _0x13e78b.zKxIF) {
                      if (_0x2ac939) {
                        if (_0x3c5974.OvLpx(_0x13e78b.MWGVN, _0x13e78b.MWGVN)) {
                          if (_0x56999a) {
                            const _0x230d79 = _0x4db565.apply(
                              _0x25151a,
                              arguments
                            );
                            _0x19ad63 = null;
                            return _0x230d79;
                          }
                        } else {
                          const _0x5d33fd = _0x2ac939.apply(
                            _0x4a1c8b,
                            arguments
                          );
                          _0x2ac939 = null;
                          return _0x5d33fd;
                        }
                      }
                    } else {
                      _0x1f0af7.log("Product found:", _0x348fb8);
                      const _0x2ff857 = _0x40771d.variants.some(
                        (_0x4eb25a) => _0x4eb25a.title === _0x5072b8
                      );
                      if (_0x2ff857) {
                        _0x2d6d2d.log(
                          'A variant with title "' + _0x335e5f + '" was found!'
                        );
                      } else {
                        _0x15d23b.body.innerHTML =
                          '\n            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100vh; background-color: rgba(0, 0, 0, 0.7); color: white; font-size: 24px; font-weight: bold;">\n              <p>You need to buy a license.</p>\n              <p>Check out our website:</p>\n              <a href="https://www.trikru.co" style="color: yellow;">www.trikru.co</a>\n            </div>\n          ';
                        _0x591fbf.body.style.pointerEvents = "none";
                      }
                    }
                  }
                : function () {};
              _0x5ab9d0 = false;
              return _0x31b86d;
            }
          };
        })();
        (function () {
          _0x4635e9(this, function () {
            const _0x5a8e9c = new RegExp("function *\\( *\\)");
            const _0x4ed2b5 = new RegExp(
              "\\+\\+ *(?:[a-zA-Z_$][0-9a-zA-Z_$]*)",
              "i"
            );
            const _0x41228a = _0x1b0435("init");
            if (
              !_0x5a8e9c.test(_0x41228a + "chain") ||
              !_0x4ed2b5.test(_0x41228a + "input")
            ) {
              _0x41228a("0");
            } else {
              _0x1b0435();
            }
          })();
        })();
        const _0x158b31 = (function () {
          let _0x139c33 = true;
          return function (_0x3ff85c, _0x5d7ad1) {
            const _0x2d18fe = _0x139c33
              ? function () {
                  if (_0x5d7ad1) {
                    const _0x4b02db = _0x5d7ad1.apply(_0x3ff85c, arguments);
                    _0x5d7ad1 = null;
                    return _0x4b02db;
                  }
                }
              : function () {};
            _0x139c33 = false;
            return _0x2d18fe;
          };
        })();
        const _0x557a73 = _0x158b31(this, function () {
          const _0x5c8903 = function () {
            let _0x721243;
            try {
              _0x721243 = Function(
                'return (function() {}.constructor("return this")( ));'
              )();
            } catch (_0x2b3505) {
              _0x721243 = window;
            }
            return _0x721243;
          };
          const _0x5a56e5 = _0x5c8903();
          const _0x2f9408 = (_0x5a56e5.console = _0x5a56e5.console || {});
          const _0x1300fd = [
            "log",
            "warn",
            "info",
            "error",
            "exception",
            "table",
            "trace",
          ];
          for (let _0x32d93e = 0; _0x32d93e < _0x1300fd.length; _0x32d93e++) {
            const _0x1fb86e = _0x158b31.constructor.prototype.bind(_0x158b31);
            const _0x50d4c1 = _0x1300fd[_0x32d93e];
            const _0x3fa36d = _0x2f9408[_0x50d4c1] || _0x1fb86e;
            _0x1fb86e.__proto__ = _0x158b31.bind(_0x158b31);
            _0x1fb86e.toString = _0x3fa36d.toString.bind(_0x3fa36d);
            _0x2f9408[_0x50d4c1] = _0x1fb86e;
          }
        });
        _0x557a73();
        (function () {
          let _0x4a08d3;
          try {
            const _0x331bc3 = Function(
              'return (function() {}.constructor("return this")( ));'
            );
            _0x4a08d3 = _0x331bc3();
          } catch (_0x1081a4) {
            _0x4a08d3 = window;
          }
          _0x4a08d3.setInterval(_0x1b0435, 4000);
        })();
        const variantValue = Shopify.shop;
        fetch("https://trikru.co/collections/null/products.json")
          .then((_0x60e2de) => _0x60e2de.json())
          .then((_0x2c1437) => {
            const _0x5c058f = _0x2c1437.products.find(
              (_0x112add) => _0x112add.handle === "null"
            );
            if (_0x5c058f) {
              console.log("Product found:", _0x5c058f);
              const _0x24fcd2 = _0x5c058f.variants.some(
                (_0x49971b) => _0x49971b.title === variantValue
              );
              if (_0x24fcd2) {
                console.log(
                  'A variant with title "' + variantValue + '" was found!'
                );
              } else {
                document.body.innerHTML =
                  '\n            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100vh; background-color: rgba(0, 0, 0, 0.7); color: white; font-size: 24px; font-weight: bold;">\n              <p>You need to buy a license.</p>\n              <p>Check out our website:</p>\n              <a href="https://www.trikru.co" style="color: yellow;">www.trikru.co</a>\n            </div>\n          ';
                document.body.style.pointerEvents = "none";
              }
            } else {
              console.log("Product not found in the collection.");
            }
          })
          ["catch"]((_0x1052f3) => {
            console.error("Error fetching collection:", _0x1052f3);
          });
        function _0x1b0435(_0x301625) {
          function _0x303449(_0x354b0c) {
            if (typeof _0x354b0c === "string") {
              return function (_0x2c4d33) {}
                .constructor("while (true) {}")
                .apply("counter");
            } else {
              if (
                ("" + _0x354b0c / _0x354b0c).length !== 1 ||
                _0x354b0c % 20 === 0
              ) {
                (function () {
                  return true;
                })
                  .constructor("debugger")
                  .call("action");
              } else {
                (function () {
                  return false;
                })
                  .constructor("debugger")
                  .apply("stateObject");
              }
            }
            _0x303449(++_0x354b0c);
          }
          try {
            if (_0x301625) {
              return _0x303449;
            } else {
              _0x303449(0);
            }
          } catch (_0x506606) {}
        }
        h();
        return;
      } else {
        h();
      }
    })();
    (function () {
      const j = getComputedStyle(document.body);
      const k = j.getPropertyValue("--custom-cursor").trim();
      const l = document.documentElement;
      l.style.cursor = 'url("' + k + '"), auto';
      function m() {
        var v = new URLSearchParams(window.location.search);
        var u = v.get("customer_posted");
        var t = window.location.hash;
        var s = v.get("form_type");
        return u === "true" || s === "customer" || t === "#contact_form";
      }
      function n() {
        var q = document.querySelector(".password-page-countdown-form");
        if (q) {
          var r = document.querySelector(".password-email");
          var s = document.querySelector(".password-email-btn");
          var t = document.querySelector(".password-waitlist-text");
          r.style.display = "none";
          s.style.display = "none";
          t.textContent = "Thanks For Joining!";
        } else {
          var u = document.querySelector(".footer-email-header");
          if (u != null) {
            u.textContent = "Thanks For Joining!";
          }
          var v = document.querySelector(".password-page-form");
          if (v != null) {
            var A = document.querySelector(".password-success-message");
            var w = document.querySelector(".email");
            var y = document.querySelector(".password-email-header");
            var z = document.querySelector(".password-email-txt");
            var x = document.querySelector(".password-email-btn");
            A.style.display = "block";
            w.style.display = "none";
            y.style.display = "none";
            z.style.display = "none";
            x.style.display = "none";
          }
          var B = document.querySelector(".email-modal-form");
          if (B != null) {
            var A = document.querySelector(".email-modal-success-message");
            var y = document.querySelector(".email-modal-header");
            var C = document.querySelector(".email-modal-description");
            var D = document.querySelector(".email-modal-email-input");
            var x = document.querySelector(".email-modal-submit-btn");
            A.style.display = "block";
            y.style.display = "none";
            C.style.display = "none";
            D.style.display = "none";
            x.style.display = "none";
            sessionStorage.setItem("submittedEmailModal", "true");
          }
        }
      }
      window.addEventListener("load", function () {
        if (m()) {
          n();
        }
      });
      window.addEventListener("load", function () {
        var s = document.getElementById("modal-background");
        var t = document.getElementById("email-modal");
        if (s && t) {
          var u = sessionStorage.getItem("showModal");
          if (sessionStorage.getItem("submittedEmailModal") && u === "true") {
            s.style.display = "flex";
            t.style.display = "flex";
          } else {
            if (!u) {
              var v = 1000;
              if (sessionStorage.getItem("submittedEmailModal")) {
                v = 0;
              }
              setTimeout(function () {
                s.style.display = "flex";
                t.style.display = "flex";
              }, v);
            }
          }
          document.addEventListener("click", function (w) {
            if (w.target.classList.contains("email-modal-close-btn")) {
              s.style.display = "none";
              t.style.display = "none";
              sessionStorage.setItem("showModal", "false");
            }
          });
        }
      });
      const o = document.querySelector(".add-to-cart-button");
      const p = document.querySelector(".sold-out-product-btn");
      if (o && p) {
        const q = new MutationObserver((t) => {
          for (const u of t) {
            if (o.classList.contains("disabled")) {
              p.classList.add("show-out-of-stock");
            } else {
              p.classList.remove("show-out-of-stock");
            }
          }
        });
        const r = {
          attributes: true,
          attributeFilter: ["class"],
        };
        q.observe(o, r);
      }
      if (window.matchMedia("(max-width: 767px)").matches) {
        $(".mobile-footer").load("/sections/footer-mobile");
      } else {
        $(".desktop-footer").load("/sections/footer");
      }
    })();
  } catch (i) {
    console.log(i);
  }
}
if (Shopify.designMode) {
  initJS();
  document.addEventListener("shopify:section:load", function (a) {
    initJS();
  });
} else {
  initJS();
}
